import React from "react";
import PropTypes from "prop-types";
import { change } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/PurchaseOrders/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import DetailFields from "MODULES/PurchaseOrders/shared/DetailFields";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import { PAYMENT_TERMS } from "APP_ROOT/constants";
import validate from "./validate";

const formName = "editPurchaseOrder";

export class Form extends React.Component {
  state = {
    contacts: []
  };

  setPaymentTerms = val => {
    this.props.setPurchaseOrder(val);
  };

  notifyForm = company => this.setState({ company });

  renderBuyerDiscrepancyWarning() {
    if (!this.props.purchaseOrder.buyers_discrepancy) {
      return null;
    }

    return (
      <div className="alert alert-warning">
        <i className="fa fa-warning" />
        &nbsp;&nbsp; One or more Line Items in this PO do not have the same
        Buyer details. Changing the Buyer details on this form, will update
        Buyer details on all underlying Line Items.
      </div>
    );
  }

  render() {
    const { purchaseOrder } = this.props;
    const { company } = this.state;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          {this.renderBuyerDiscrepancyWarning()}
          <CompanyAddressWarning company={company} />
          <DetailFields
            purchaseOrder={purchaseOrder}
            selectedBuyer={purchaseOrder.buyer}
            selectedCoBuyer={purchaseOrder.co_buyer}
            selectedThirdBuyer={purchaseOrder.third_buyer}
            setSelectedCompany={this.notifyForm}
            setPaymentTerms={this.setPaymentTerms}
            formName={formName}
            setPrimaryContact={false}
          />
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  setPurchaseOrder: PropTypes.func,
  purchaseOrder: PropTypes.instanceOf(Object)
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.update(data)),
  setPurchaseOrder: val => dispatch(change(formName, PAYMENT_TERMS, val))
}))(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Edit/Form.jsx